import { Select, IProps as SelectProps } from 'components/atoms/Select/Select.components';
import useCatalog from 'hooks/useCatalogs/useCatalogs';
import { catalogoLenguage, catalogoPersonal } from 'utils/helpers/dictionaries';

interface CatalogSelectProps extends SelectProps {
  catalog: catalogoPersonal;
  language?: catalogoLenguage[];
  filter?: catalogoLenguage[];
  select?: string;
  name?: string;
  labelOption?: string;
  valueOption?: string;
  isEntity?: boolean;
}

export default function CatalogSelect({ catalog, language, filter, select, name, labelOption, isEntity, ...rest }: Readonly<CatalogSelectProps>) {

  const { data, loading } = useCatalog(catalog, language, filter, undefined, select, isEntity);
  const options: SelectProps['options'] = loading ? [{ label: 'Cargando', value: 'Cargando' }] : data.map((value) => ({ value, label: value[labelOption as any] ?? value }));

  return (
    <Select
      options={options}
      {...rest}
      handleChange={(value) => {
        rest.handleChange(value ?? '');
      }}
    />
  );
}
